var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-text-input',_vm._g(_vm._b({attrs:{"name":_vm.name,"rules":_vm.getRules,"value":_vm.value,"maxlength":"10","counter":false}},'app-text-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }